import axios from "axios";
import { errorToast } from "@idwal/idwal-react-components";

export type SuggestedCodesResponse = {
  defects: Array<{
    defect_id: string;
    defect_code: string[];
    confidence_scores: number[];
    observation_code: string;
    processing_path: string;
  }>;
  processing_time: number;
  model_version: string;
};

export const getSuggestedCodes = async (
  category: string,
  description: string,
  defectId: string
): Promise<SuggestedCodesResponse | null> => {
  const url = process.env.REACT_APP_IDWAL_INTERNAL_API + `/code-mapping/validate-defects`;
  const headers = {
      "Content-Type": "application/json",
      "x-api-key": process.env.REACT_APP_IDWAL_INTERNAL_API_KEY
  };

  const data = { defects: [{defect_id: defectId, category, defect_text: description }]};
  
  try {
    const response = await axios.post(url, data, { headers });
    return response.data;
  } catch (error) {
    errorToast("Unable to retrieve suggested codes right now.");
  }

  return null;
};
